import { motion } from "motion/react";

const pillars = [
  {
    emoji: "🤝",
    title: "Trato directo",
    text: "Hablas conmigo desde el primer contacto hasta el final del trabajo. Sin call centers, sin gestores.",
    border: "border-transparent",
  },
  {
    emoji: "👷",
    title: "Técnico propio en Málaga",
    text: "Nuestro taller está en San Andrés, Málaga. No subcontratamos a nadie: nosotros mismos hacemos cada instalación y reparación.",
    border: "border-primary",
  },
  {
    emoji: "🚫",
    title: "Sin plataformas ni intermediarios",
    text: "No dependo de plataformas ni franquicias. Precios justos y trato 100% personal, de persona a persona.",
    border: "border-transparent",
  },
];

export default function AboutSection() {
  return (
    <section className="bg-text-primary py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-3">
            Tu técnico de confianza en Málaga
          </h2>
          <p className="font-body text-base text-slate-300 max-w-2xl mx-auto">
            Soy técnico de persianas, toldos y mosquiteras en Málaga desde 2015. Hablas directamente conmigo: sin plataformas, sin intermediarios.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              className={`bg-slate-800 rounded-[20px] p-8 border-2 ${p.border} hover:bg-slate-700/50 transition-colors`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <div className="text-4xl mb-4">{p.emoji}</div>
              <h3 className="font-heading font-bold text-[22px] text-white mb-3">
                {p.title}
              </h3>
              <p className="font-body text-base text-slate-300 leading-relaxed">
                {p.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}